import qs from "qs";
import { saveAs } from 'file-saver';
import { apiClients } from "../../settings"
import { IDocumentDetailsData, IShipmentDocumentDetailsData } from "./Shipment.DocumentDetails.types";

function downloadFile(blob: any, filename: any) {
  saveAs(blob, filename);
}

export default class DocumentDetailsApi {

  static async getDocument(queryKey: any, logout: any) {
    let [_, document] = queryKey.queryKey;
    try {
      let res = await apiClients[2].post(`/V1/documents/GetDocument`, document, {
        responseType: 'blob',
      });
      downloadFile(res.data, document.fileName);
      return res.data;
    } catch (e: any) {
      if (e.response && e.response.status === 403) {
        console.log('User is not authorized. Logging out.');
        window.alert("Session Expired Please Login Again");
        logout();
      }
      console.error('Could not get Document Details data: ', e.message);
      return undefined;
    }
  }

  static async getDocumentsByShipmentId({ queryKey }: any, logout: any) {
    const [_, referenceNumber] = queryKey;
    try {
      let res = await apiClients[2].get(`/V1/documents/GetListOfDocument/${referenceNumber}`);
      return res.data as IDocumentDetailsData[];
    } catch (e: any) {
      if (e.response && e.response.status === 403) {
        console.log('User is not authorized. Logging out.');
        window.alert("Session Expired Please Login Again");
        logout();
      }
      console.error('Could not get Documents data: ', e.message);
      return undefined;
    }
  }

  //static async getDocumentDetailsData({queryKey}: any) {
  //    let containerNumber = queryKey[1].containerNumber;
  //    try {
  //        let res = await axios.get(`/Shipments/${containerNumber}/ContainerDetails`);
  //        return res.data as IDocumentDetailsData;
  //    } catch (e: any) {
  //       console.error('Could not get Document Details data: ', e.message);
  //        return undefined;
  //    }
  //}
}